import React from "react"
import styled from "styled-components"

import { Heading, Paragraph } from "@atoms/typography"
import { Column } from "@atoms/layout"
import Card from "@molecules/cards/card"

const CardSearch = ({ result }) => {
  return (
    <ColumnSearch third>
      <Search>
        <a href={result.url}>
          <Heading
            html="h4"
            level="h4"
            dangerouslySetInnerHTML={{
              __html: result.title,
            }}
          />
          <Content
            level="sm"
            dangerouslySetInnerHTML={{
              __html: result.body,
            }}
          />
          <HeadingRead html="h6" level="sh" gray strong noMargin>
            Read Post
          </HeadingRead>
        </a>
      </Search>
    </ColumnSearch>
  )
}

export default CardSearch



const ColumnSearch = styled(Column)`
  transition: var(--transitionBase);
  margin-bottom: var(--spacing--xs);

  a {
    text-decoration: none;
  }
`

const Content = styled(Paragraph)`
  margin-bottom: var(--spacing--xs);
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;

  strong {
    color: var(--aqua--80);
    position: relative;
    z-index: 0;
    
    &:before {
      background-color: var(--aqua--00);
      content: "";
      height: 100%;
      position: absolute;
      top: 0;
      left: -10%;
      width: 120%;
      z-index: -1;
    }
  }
`

const HeadingRead = styled(Heading)`
  transition: var(--transitionBase);
`

const Search = styled(Card)`
  padding: var(--spacing--xs);

  &:hover {
    ${HeadingRead} {
      color: var(--colorPrimary);
    }
  }
`
